<div class="stepContent sub-content" *ngIf="isUploadEnabled">
	<div class="site-desc-container">
		<div class="header">
			<div class="title">Site definition</div>
		</div>
		<div class="site-desc">
			<div class="icon">
				<img src={{siteImagePath}} alt="image">
			</div>
			<div class="desc-content">
				<div class="label">{{wizardCtrl.wizardService.output.name}}</div>
				<div class="description" *ngIf="wizardCtrl.wizardService.output.description">
					{{wizardCtrl.wizardService.output.description}}</div>
				<div class="location">
					<div class="city">{{wizardCtrl.wizardService.output.location.city}}</div>
					<div class="country">
						<span *ngIf="wizardService.output.location.state">{{wizardService.output.location.state}},</span>
						{{wizardCtrl.wizardService.output.location.country}}
					</div>
				</div>
				<div class="tags" *ngIf="wizardCtrl.wizardService.output.tags">
					<div class="city">Tags:</div>
					<div class="label" *ngFor="let tag of wizardCtrl.wizardService.output.tags; let $index = index;">
						{{tag}}
						<span *ngIf="$index < (wizardCtrl.wizardService.output.tags.length-1)">, </span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="subnet-defs-container">
		<div class="header">
			<div class="title">Subnet definition</div>
		</div>
		<div class="subnet-defs">
			<div class="icon">
				<img src="images/subnets.svg" alt="subnets">
			</div>
			<div class="list">
				<div class="subnet-header">
					<div class="subnet-header-wrapper">
						<div class="subnet-name">
							<div class="subnet-name-label">Subnet name</div>
						</div>
						<div class="subnet-range">
							<div class="subnet-range-label">Subnet range</div>
						</div>
						<div></div>
					</div>
				</div>
				<div class="subnet-list">
					<div class="subnet" *ngFor="let subnet of wizardCtrl.wizardService.output.subnets">
						<div class="subnet-name">
							<div class="subnet-name-label">{{subnet.name}}</div>
						</div>
						<div class="subnet-range">{{subnet.subnet}}</div>
						<div class="subnet-action">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
